import React, { useContext, useEffect, useState } from 'react';
import { 
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    useTheme,
    useMediaQuery,
    Typography
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { useAuth0 } from "@auth0/auth0-react";
import { useAbortController } from '../contexts/AbortControllerContext';
import ProjectContext from '../contexts/ProjectContext';
import ControlBar from '../components/structure/ControlBar';
import ControlButton from '../components/structure/ControlButton';
import ItemList from '../components/menuitem/ItemList';
import FullDataGrid from '../components/datagrid/FullDataGrid';
import SecondaryButton from '../components/buttons/SecondaryButton';
import UploadEdlDialog from '../components/dialog/UploadEdlDialog';
import LaptopIcon from '@mui/icons-material/Laptop';

import { Tab, Tabs } from '@mui/material';
import { itemIcons } from '../components/SideItems/SideItems';
import ControlDivider from '../components/structure/ControlDivider';
import {useFetch} from '../components/auth/useFetch';

// In milliseconds
let minimumLoadingAnimationDuration = 2000;

export default function EdlView(props) {

    const viewname = 'Manage EDL'
    const { makeTour, setIsLoading } = props

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('md'))

    const { isAuthenticated } = useAuth0();
    const { registerController, unregisterController } = useAbortController()
    const projectContext = useContext(ProjectContext);

    const [edls, setEdls] = useState([])
    const [edlData, setEdlData] = useState([])
    const [activeIndex, setActiveIndex] = useState(null)
    const [openUploadDialog, setOpenUploadDialog] = useState(false)
    const [uploadRef, setUploadRef] = useState(null)

    const [loading, setLoading] = useState(false)
    const fetchWithAuth = useFetch()

    const fileDialog = (e) => {
        setUploadRef(e.currentTarget)
        setOpenUploadDialog((prevState) => !prevState)
    }

    const clickAway = () => {
        setOpenUploadDialog(false)
    }

    const edlColumns = [
        { field: 'edl_name', headerName: 'EDL Name', width: 250 },
        { field: 'num', headerName: 'Num', width: 70 },
        { field: 'vfxname', headerName: 'VFX Name', width: 170 },
        { field: 'progression', headerName: 'Last Update', width: 200},   
        { field: 'clipname', headerName: 'Clipname', width: 170 },
        { field: 'mediapath', headerName: 'Media Path', width: 300 },
        { field: 'cameraformat', headerName: 'Camera Format', width: 100 },
        { field: 'detectedcameraformat', headerName: 'Detected Camera Format', width: 100 },
        { field: 'length', headerName: 'Length', width: 100 },
        { field: 'scene', headerName: 'Scene', width: 100 },
        { field: 'take', headerName: 'Take', width: 100 },
        { field: 'shotprod', headerName: 'ShotProd', width: 100 },
        { field: 'framerate', headerName: 'Frame Rate', width: 100 },
        { field: 'file_type', headerName: 'File Type', width: 100}, 
        { field: 'tapes', headername: 'Tapes', width: 160, renderCell:(params)=>
                                                                            <Box>{params.row.tapes.join(', ')}</Box>},
        { field: 'rec_start_tc', headerName: 'Rec Start TC', width: 100 },
        { field: 'rec_end_tc', headerName: 'Rec End TC', width: 100 },
        { field: 'src_start_tc', headerName: 'Src Start TC', width: 100 },
        { field: 'src_end_tc', headerName: 'Src End TC', width: 100 },
        { field: 'customframestart', headerName: 'Custom Frame Start', width: 100 },
        { field: 'expected_duration', headerName: 'Expected Duration', width: 130 },
        { field: 'expected_frames', headerName: 'Expected Total Frames', width: 130 },
        { field: 'expected_resolution', headerName: 'Expected Resolution', width: 130 },
        { field: 'file_duration', headerName: 'Rendered File Duration', width: 150 },
        { field: 'file_exr_count', headerName: 'Generated EXR count', width: 140 },
        { field: 'file_res', headerName: 'Generated Resolution', width: 140 },        
        { field: 'exr_progress',    headerName: 'EXR Progress',        width: 145, renderCell:(params) => 
                                                                            <Box 
                                                                                border={1}
                                                                                borderColor="rgba(255,255,255,0.8)"
                                                                                borderRadius={2}
                                                                                minWidth="120px"
                                                                                maxWidth="120px"
                                                                                minHeight="20px"
                                                                                maxHeight="20px">
                                                                                    {params.row.exr_progress < 50 ?
                                                                                    <div style={{ width:"120px", height:"20px", background: "linear-gradient(90deg, rgba(200, 0, 0, 0.85) "+params.row.exr_progress+"%, rgba(255,255,255,0) 0%)", textAlign: "center", textJustify: "center"}}>
                                                                                        <Box 
                                                                                            display="flex"
                                                                                            alignItems="center"
                                                                                            justifyContent="center"
                                                                                            minWidth="120px"
                                                                                            maxWidth="120px"
                                                                                            minHeight="20px"
                                                                                            maxHeight="20px">
                                                                                            {params.row.exr_injected + '/' + params.row.total_frames + ' | ' + params.row.exr_progress + '%'}
                                                                                        </Box>
                                                                                    </div>
                                                                                    :
                                                                                    params.row.exr_progress < 90 ?
                                                                                    <div style={{ width:"120px", height:"20px", background: "linear-gradient(90deg, rgba(180, 180, 0, 0.85) "+params.row.exr_progress+"%, rgba(255,255,255,0) 0%)", textAlign: "center", textJustify: "center"}}>
                                                                                        <Box 
                                                                                            display="flex"
                                                                                            alignItems="center"
                                                                                            justifyContent="center"
                                                                                            minWidth="120px"
                                                                                            maxWidth="120px"
                                                                                            minHeight="20px"
                                                                                            maxHeight="20px">
                                                                                            {params.row.exr_injected + '/' + params.row.total_frames + ' | ' + params.row.exr_progress + '%'}
                                                                                        </Box>
                                                                                    </div>
                                                                                    :
                                                                                    <div style={{ width:"120px", height:"20px", background: "linear-gradient(90deg, rgba(76, 175, 80, 0.85) "+params.row.exr_progress+"%, rgba(255,255,255,0) 0%)", textAlign: "center", textJustify: "center"}}>
                                                                                        <Box 
                                                                                            display="flex"
                                                                                            alignItems="center"
                                                                                            justifyContent="center"
                                                                                            minWidth="120px"
                                                                                            maxWidth="120px"
                                                                                            minHeight="20px"
                                                                                            maxHeight="20px">
                                                                                            {params.row.exr_injected + '/' + params.row.total_frames + ' | ' + params.row.exr_progress + '%'}
                                                                                        </Box>
                                                                                </div>
                                                                                    }
                                                                            </Box>}]



    useEffect(() => {
        setIsLoading(true)
        setLoading(true)
        let startTime = new Date();

        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/edllist`
        isAuthenticated && (async () => {
        try {
            await fetchWithAuth(url, {
                headers:{
                    'X-Project-ID': projectContext?.project_db
                },
            })
                .then((response) => response.json())
                .then((res) => {
                    setEdls(res.rows.map((item) => item.edl_name))
                    // Handle loading anim time
                    let endTime = new Date();
                    if (endTime.getTime() - startTime.getTime() < minimumLoadingAnimationDuration){
                    let waitTime = minimumLoadingAnimationDuration - (endTime.getTime() - startTime.getTime());
                    setTimeout(()=>{
                        setLoading(false)
                        setIsLoading(false)
                    }, waitTime)
                    } else {
                        setLoading(false)
                        setTimeout(() => {
                            setIsLoading(false)
                        }, 400);
                    }
                })
        } catch (e) {
            console.error(e);
        }
        })();
    }, [isAuthenticated])

    useEffect(() => {
        makeTour([
            {
                target: '#edl-view-edl-list',
                content: 'View all the EDLs that have been uploaded. Click on one of the items in this list to preview the EDL.',
                placementBeacon: 'top'
            },
            {
                target: '#edl-view-edl-preview',
                content: 'Your selected EDL will appear here',
            },
            {
                target: '#edl-view-upload-button',
                content: 'Upload EDLs using this button. Click this button to bring up the upload dialog.',
            },
            {
                target: '#edl-view-download-button',
                content: 'Download the selected EDL as a CSV file.',
            },
        ])
    }, [])

    const fetchEdl = (index) => {
        const edlDetailsController = registerController(``)
        setEdlData([])
        setLoading(true)
        let startTime = new Date();
        setActiveIndex(index)
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/edldetails/?edl_name=${edls[index]}`
        fetchWithAuth(url, {
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
            signal: edlDetailsController.signal
        })
            .then((response) => response.json())
            .then((res) => {
                setEdlData(res)
                // Handle loading anim time
                let endTime = new Date();
                if (endTime.getTime() - startTime.getTime() < minimumLoadingAnimationDuration){
                let waitTime = minimumLoadingAnimationDuration - (endTime.getTime() - startTime.getTime());
                setTimeout(()=>{setLoading(false)}, waitTime)
                } else {
                    setLoading(false)
                }
            })
            .catch(e => {
                if(e.name !== 'AbortError'){
                    console.error(e);
                }
            })
            .finally(() => unregisterController(edlDetailsController))
    }

    const deleteEdl = async (index) => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/edldelete/?edl_name=${edls[index]}`
        await fetchWithAuth(url, {
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        })
            .then((response) => response.json())
            .then((res) =>
                setEdls((prev) => {
                    prev.splice(index, 1)
                    return [...prev]
                })
            )
            .then(() => {
                if(activeIndex === index){
                    setEdlData([])
                }
            })
            .catch(e => {
                console.error(e);
            })
    }

    const downloadAle = (index) => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/edlale/?edl_name=${edls[index]}`
        fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'X-Project-ID': projectContext?.project_db,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify("payload"),
        })
            .then((response) => response.blob())
            .then((res) => {
                const url = window.URL.createObjectURL(res);
                const link = document.createElement('a');
                link.href = url;
               const filename = `${edls[index].slice(0, -4)}.ALE`
               link.setAttribute('download', filename);
               
               document.body.appendChild(link);
               link.click();
               link.parentNode.removeChild(link);
            })
            .catch(e => {
                console.error(e);
            })
    }

    return (
        <React.Fragment>

            {
                // If tablet or smaller, show page unavailable
                // else show page
                isSm
                ?
                <Box
                    width={'100%'}
                    height={'100%'}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <LaptopIcon
                        sx={{
                            color: "rgba(128,128,128,0.4)",
                            fontSize: 100
                        }}
                    />
                    <Typography color={'rgba(128,128,128,1)'} component="span" variant="h7" align="left" gutterBottom>
                        Feature available on desktop/laptop
                    </Typography>
                </Box>
                :
                <Box display="flex" flexDirection="column" height={'100%'}>
                    <ControlBar>
                        <Tabs
                            value={viewname}
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto">
                            <Tab
                                label={
                                    <Box display="flex" alignItems="center">
                                        {itemIcons[viewname]}
                                        <Box ml={1}>{viewname}</Box>
                                    </Box>
                                }
                                style={{ textTransform: 'none', fontWeight: 'bold', color: 'white' }} />
                        </Tabs>

                        <ControlDivider />
                        
                        <div id='edl-view-upload-button'>
                        <ControlButton
                            title='Upload EDL'
                            clicked={fileDialog}>
                                <FileUploadIcon style={{fill: 'white'}} />
                        </ControlButton>
                        </div>
                        <div id='edl-view-download-button'>
                        <ControlButton
                            disabled={activeIndex !== null ? false : true}
                            title='Download ALE'
                            clicked={() => downloadAle(activeIndex)}>
                                <DownloadIcon style={{fill: 'white'}} />
                        </ControlButton>
                        </div>
                    </ControlBar>
                    <UploadEdlDialog open={openUploadDialog} anchorEl={uploadRef} clickAway={clickAway} updateParentList={setEdls} />
                    <Box
                        display="flex"
                        flexDirection="row"
                        height='100%'
                        width='100%'
                    >
                        <Box
                            id='edl-view-edl-list'
                            height='100%'
                            minWidth='300px'
                            maxWidth='300px'
                            bgcolor='rgba(0,0,0,0.9)'
                            overflow={'auto'}
                            
                        >
                            <List sx={{
                                color: 'white',
                                width: '100%'}}
                            >
                                {edls.map((edl, index) => (
                                    <ItemList
                                        key={index}
                                        active={index === activeIndex ? true : false}
                                        title={edl} 
                                        // label={file['source']} 
                                        onItemClick={() => fetchEdl(index)}
                                        iconButton={
                                            <SecondaryButton
                                                onClick={() => deleteEdl(index)}
                                                hoverColor='red'
                                                icon={<DeleteForeverIcon />}
                                            />
                                        }
                                    />
                                ))}
                            </List>
                        </Box>
                        <Box mx={0.5} height={'100%'} width={'100%'}>
                            <Box id='edl-view-edl-preview' height={'100%'} width={'100%'} >
                                <FullDataGrid 
                                    rows={edlData} 
                                    columns={edlColumns} 
                                    disableSelection 
                                    loading={loading}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }
        </React.Fragment>
    )
}